<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="90px">
        <el-form-item label="渠道名称">
          <el-input
            v-model="searchData.channelName"
            size="small"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input
            v-model="searchData.id"
            size="small"
            placeholder="请输入用户ID"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            v-model="searchData.memberName"
            size="small"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="searchData.mobile"
            size="small"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input
            v-model="searchData.identityNo"
            size="small"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            style="width: 250px"
            size="small"
            v-model="searchData.timeSlot"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label=" ">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="getList()"
            >搜索</el-button
          >
          <el-button
            type="info"
            size="small"
            icon="el-icon-refresh"
            @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <tp-table
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />

    <!-- 加入名单弹窗 -->
    <el-dialog
      :title="`将该用户加入${rosterForm.riskLevel == 2 ? '黑' : '白'}名单，是否继续？`"
      :visible.sync="rosterDialog"
      width="500px"
    >
      <el-form
        ref="rosterForm"
        :model="rosterForm"
        :rules="rosterRules"
        label-width="80px"
      >
        <el-form-item label="备注" prop="rosterRemark">
          <el-input
            v-model="rosterForm.rosterRemark"
            type="textarea"
            :rows="4"
            placeholder="请输入备注（非必填）"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rosterDialog = false">取消</el-button>
        <el-button type="primary" @click="submitRoster">确定</el-button>
      </div>
    </el-dialog>

    <!-- 更新证件弹窗 -->
    <el-dialog title="更新证件" :visible.sync="idCardDialog" width="800px">
      <div class="update-idcard-form">
        <FileUpload
          class="idcard-uploader"
          :name.sync="idCardForm.front"
          :url="idCardForm.frontUrl"
          >身份证人像面</FileUpload
        >
        <FileUpload
          class="idcard-uploader"
          :name.sync="idCardForm.back"
          :url="idCardForm.backUrl"
          >身份证国徽面</FileUpload
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="idCardDialog = false">取消</el-button>
        <el-button
          type="primary"
          size="small"
          :disabled="idCardSubmitDisabled"
          @click="submitUpdateIdCard"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getListAPI, addRosterAPI, idCardOcrAPI } from "./api";
import { authBtnMixin } from "@/mixins/authBtnMixin";
const columns = [
  {
    label: "ID",
    prop: "id",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["id"]}</p>;
    },
  },
  {
    label: "手机号",
    prop: "mobile",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["mobile"]}</p>;
    },
  },
  {
    label: "姓名",
    prop: "memberName",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["memberName"]}</p>;
    },
  },
  {
    label: "身份证号",
    prop: "identityNo",
    minWidth: "180",
    customRender(h, row) {
      return <p>{row["identityNo"]}</p>;
    },
  },
  {
    label: "性别",
    prop: "genderName",
    minWidth: "80",
    customRender(h, row) {
      return <p>{row["genderName"]}</p>;
    },
  },
  {
    label: "出生日期",
    prop: "birthDay",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["birthDay"]}</p>;
    },
  },
  {
    label: "状态",
    prop: "status",
    minWidth: "100",
    customRender(h, row) {
      return (
        <div>
          <el-tag v-show={row["status"] == 1} type="success" size="small">
            正常
          </el-tag>
          <el-tag v-show={row["status"] == 2} type="danger" size="small">
            注销
          </el-tag>
        </div>
      );
    },
  },
  {
    label: "渠道归属",
    prop: "channel",
    minWidth: "130",
    customRender(h, row) {
      return <p>{row["channel"]?.["channelName"]}</p>;
    },
  },
  {
    label: "创建时间",
    prop: "createTime",
    minWidth: "180",
    customRender(h, row) {
      return <p>{row["createTime"]}</p>;
    },
  },
  {
    label: "操作",
    width: "230",
    fixed: "right",
    customRender(h, row) {
      return (
        <div>
          <el-link
            style={{ marginRight: "5px" }}
            disabled={!this.isShowBtn(this.AUTH_BTN.member_list_add_black)}
            underline={false}
            type="primary"
            onClick={() => this.addRoster(row["id"], 2)}
          >
            <span>加入黑名单</span>
          </el-link>
          <el-link
            style={{ marginRight: "5px" }}
            disabled={!this.isShowBtn(this.AUTH_BTN.member_list_add_white)}
            underline={false}
            type="primary"
            onClick={() => this.addRoster(row["id"], 1)}
          >
            <span>加入白名单</span>
          </el-link>
          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.member_list_update_idcard)}
            underline={false}
            type="primary"
            onClick={() => this.openIdCardDialog(row)}
          >
            <span>更新证件</span>
          </el-link>
        </div>
      );
    },
  },
];
export default {
  name: "List",
  mixins: [authBtnMixin],
  data() {
    return {
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        channelName: "",
        id: "",
        memberName: "",
        mobile: "",
        identityNo: "",
        timeSlot: [],
        leftCreateDate: "",
        rightCreateDate: "",
      },
      // 加入名单弹窗相关数据
      rosterDialog: false,
      rosterForm: {
        id: "",
        riskLevel: 1,
        rosterRemark: "",
      },
      rosterRules: {
        rosterRemark: [
          { max: 200, message: "备注不能超过200个字符", trigger: "blur" },
        ],
      },
      // 更新证件弹窗相关数据
      idCardDialog: false,
      idCardForm: {
        id: "",
        front: "",
        back: "",
        frontUrl: "",
        backUrl: "",
      },
    };
  },
  provide() {
    return {
      context: this,
    };
  },
  computed: {
    idCardSubmitDisabled() {
      return !this.idCardForm.front || !this.idCardForm.back;
    },
  },
  activated() {
    this.getList();
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },

  methods: {
    async getList() {
      const { channelName, id, memberName, mobile, identityNo, timeSlot } =
        this.searchData;
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        channelName,
        id,
        memberName,
        mobile,
        identityNo,
      };

      if (timeSlot && timeSlot.length > 0) {
        params.leftCreateDate = timeSlot[0] || "";
        params.rightCreateDate = timeSlot[1] || "";
      }
      const res = await getListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    // 加入黑/白名单
    addRoster(id, riskLevel) {
      this.rosterForm.id = id;
      this.rosterForm.riskLevel = riskLevel;
      this.rosterForm.rosterRemark = "";
      this.rosterDialog = true;
    },
    // 提交加入名单
    async submitRoster() {
      this.$refs.rosterForm.validate(async (valid) => {
        if (valid) {
          try {
            await addRosterAPI({
              id: this.rosterForm.id,
              riskLevel: this.rosterForm.riskLevel,
              rosterRemark: this.rosterForm.rosterRemark,
            });
            this.$message.success("操作成功");
            this.rosterDialog = false;
            this.getList();
          } catch (error) {
            this.$message.error("操作失败");
          }
        }
      });
    },
    // 打开更新证件弹窗（已有证件照则回显）
    openIdCardDialog(row) {
      this.idCardForm.id = row.id;
      this.idCardForm.front = row.identityFrontImage || "";
      this.idCardForm.back = row.identityBackImage || "";
      this.idCardForm.frontUrl = row.identityFrontImageUrl || "";
      this.idCardForm.backUrl = row.identityBackImageUrl || "";
      this.idCardDialog = true;
    },
    // 提交更新证件（身份证OCR）
    async submitUpdateIdCard() {
      try {
        await idCardOcrAPI({
          id: this.idCardForm.id,
          identityFrontImage: this.idCardForm.front,
          identityBackImage: this.idCardForm.back,
        });
        this.$message.success("操作成功");
        this.idCardDialog = false;
        this.getList();
      } catch (error) {
        this.$message.error("操作失败");
      }
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 35px;
        .el-input {
          width: 250px;
        }
        .el-date-editor {
          .el-range-separator {
            padding: 0;
          }
          .el-range-input {
            width: 35%;
          }
        }
      }
    }
  }
  .el-date-editor .el-range-separator {
    padding: 0;
  }
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }
  // 操作间距由 customRender 中 el-link 的内联 marginRight 控制（scoped /deep/ 对 JSX 渲染节点的 + 组合器不可靠）
  .update-idcard-form {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    .idcard-uploader .el-upload {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 320px;
      height: 200px;
    }
    // 上传后的缩略图保持与上传框一致的尺寸和虚线框
    .idcard-uploader .single-upload-thumb {
      width: 320px;
      height: 200px;
      border: 1px dashed #d9d9d9;
    }
  }
}
</style>
